import axios from 'axios';
import * as environmentService from '../environment/environmentService';

export const oauthHeaders = () => {
    return { headers: { 'Authorization': `Bearer ${sessionStorage.getItem('oauthTokenB64')}` } };
}

export const oauthHeadersWithToken = (token) => {
    return { headers: { 'Authorization': `Bearer ${token}` } };
}

export const getOauthCode = (codeBody, authorizationHeader) => {
    return axios.post(`${environmentService.getVidCloudMgmtUrl()}/oauth/code`, codeBody, {
        headers: { 'Authorization': 'Basic ' + authorizationHeader }
    });
}